itsoftApp.createModule("select", function () {
    var module = this;

    const library = {
        select: {
            name: "choices",
            queue: [],
            started: false,
            loaded: false,
            style: "/assets/scripts/choices/choices.min.css",
            script: "/assets/scripts/choices/choices.min.js"
        }
    }

    module.selects = {
        filters: []
    }

    var setSelect = function (element) {
        var initSelect = function () {
            Choices.prototype.clearOptions = function(){
                const placeholder = this.config.choices?.find(choice => choice.placeholder);
                if(placeholder){
                    this.setChoices([placeholder], 'value', 'label', true).setChoiceByValue('');
                } else {
                    this.clearChoices();
                }
            }
            
            var form = element.closest("form");
            var selectItem = element.querySelector(".js-select-item");
            var selectWrapper = selectItem.closest(".js-select");
            // var activeOptionValue;
            // var activeSection

            var fragment = document.createDocumentFragment();

            var getSelectName = function (select, string) {
                var selectClass = string;
                return selectClass += " choices--" + select.getAttribute("id"); 
            }

            var createOptionEl = function (item) {
                var optionEl = document.createElement("option");
                var wordsArray = item.city.split("");
                var newWords = "";

                Array.prototype.forEach.call(wordsArray, function (word) {
                    newWords += itsoftApp.utils.translit(word);
                });

                newWords.replace(/\s/g, '+');

                optionEl.textContent = item.city;
                optionEl.value = newWords;

                fragment.appendChild(optionEl);
            }

            var createSelect = function () {
                var customSelect = new Choices(selectItem, {
                    position: "bottom",
                    searchEnabled: (function () {
                        if (selectItem.hasAttribute("data-search")) {
                            return true;
                        } else {
                            return false;
                        }
                    })(),
                    loadingText: "",
                    noResultsText: "",
                    noChoicesText: "",
                    itemSelectText: "",
                    shouldSort: false,
                    classNames: {
                        containerOuter: getSelectName(selectItem, "choices"),
                        placeholder: "form__select-placeholder"
                    },
                    removeItems: false,
                    callbackOnInit: function () {
                        selectWrapper.classList.add("js-inited");
                    }
                });

                var placeholder = selectWrapper.querySelector(".choices__list--dropdown .form__select-placeholder");
                var placeholderText = placeholder.textContent;
                var dropdown = selectWrapper.querySelector(".choices__list--dropdown");
                dropdown.setAttribute("data-placeholder", placeholderText);

                customSelect.passedElement.element.addEventListener(
                    "choice",
                    function (event) {
                        setTimeout(function () {
                            selectWrapper.classList.add("is-selected");

                            if (selectWrapper.classList.contains("js-error")) {
                                selectWrapper.classList.remove("js-error");
                                selectWrapper.closest(".js-error-wrapper").classList.remove("js-error-wrapper");
                            }
                        });
                    },
                    false
                );

                if (selectItem.hasAttribute("data-search")) {
                    module.selects.filters.push(customSelect);

                    var searchValue = "";

                    customSelect.passedElement.element.addEventListener(
                        "search",
                        function (event) {
                            searchValue = event.detail.value;
                        },
                        false
                    );

                    customSelect.passedElement.element.addEventListener(
                        "showDropdown",
                        function (event) {
                            var input = selectWrapper.querySelector(".choices__list--dropdown .choices__input");

                            if (input) {
                                input.value = searchValue;
                            }
                        },
                        false
                    );
                } else {
                    const formName = form.getAttribute("name");
                    if (!module.selects.hasOwnProperty(formName)) {
                        module.selects[formName] = [];
                    }
                    module.selects[formName].push(customSelect);
                }
            }

            createSelect();
        }

        new itsoftApp.modules.startLoad.callback(initSelect, library.select);
    }

    this.callback = setSelect;
});